module.exports = __webpack_public_path__ + "img/optin-1.a41318d0.png";